var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("el-card", [
    _c("div", { staticClass: "disp-flex" }, [
      _c(
        "div",
        [
          _c(
            "el-button",
            {
              attrs: { type: "text" },
              on: {
                click: function($event) {
                  return _vm.handleActionItemClick(_vm.item)
                }
              }
            },
            [
              _c("i", {
                staticClass: "el-icon-view",
                attrs: { size: "large" }
              }),
              _vm._v("\n\t\t\t\t" + _vm._s(_vm.$t("message")) + "\n\t\t\t")
            ]
          )
        ],
        1
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "mb-5 ellipsis" }, [
      _vm._v("\n\t\t" + _vm._s(_vm.item.message_by_reference.subject) + "\n\t")
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "fs-13" }, [
      _vm.item.message_by_reference && _vm.item.message_by_reference.archived_by
        ? _c("div", [
            _vm._v(
              "\n\t\t\t" + _vm._s(_vm.$tc("item.archived_by")) + "\n\t\t\t"
            ),
            _c("b", [
              _vm._v(
                "\n\t\t\t\t" +
                  _vm._s(
                    _vm.item.message_by_reference.person_by_reference.username
                  ) +
                  "\n\t\t\t"
              )
            ])
          ])
        : _vm._e()
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }